<template>
  <div v-if="id>0">
    <viewInfo :resumeId="id" :resumeType="type" :isII="isII" :keyword="keyword" :jobId="jobId"
      @resumeLoaded="onGetData">
    </viewInfo>
  </div>
  <div v-else>未找到有效简历</div>
</template>
<script>
  import viewInfo from './ResumeViewInfo';
  import {
    resumeType2Source
  } from '~/utils';
  export default {
    props: {
      type: {
        type: Number
      }, //1-乐跳可推荐，2-乐跳历史会员，3-乐跳游客 4-猎头候选人，5-O库人才(Ma...)，6-P1库人才(Mb...)
      id: {
        type: Number
      }, //全文ID:MeDataID, MaResumeID, MbResumeID
      isII: {
        type: Boolean
      },
      keyword: {
        type: String
      },
      jobId: {
        type: Number
      }
    },
    components: {
      viewInfo,
    },
    data() {
      return {
        resumeSource: 0, //全文源: 1MeData,2MaResume,3MbResume
      };
    },
    watch: {
      type: function (val) {
        this.setSource();
      }
    },
    created() {
      this.setSource();
    },
    methods: {
      onGetData(talent) {
        this.$emit('resumeLoaded', talent);
      },
      setSource() {
        this.resumeSource = resumeType2Source(this.$props.type);
      },
    },
  };
</script>